export const manualDocumentEs = {
  // duplicate-document-number dialog (existing)
  document_number_already_exists: `El número de documento ya existe`,
  document_number_exists_message: `Ya se ha asignado este número de documento: {{documentNumber}}`,
  would_you_like_to_generate_new_document_number: `¿Le gustaría generar un nuevo número de documento?`,
  regenerate_document_number: `Regenerar número de documento`,
  document_number_regenerated_successfully: `Número de documento regenerado correctamente`,

  // section headings
  verifactu_simplified_invoice: `Factura simplificada de Verifactu`,
  sii_simplified_invoice: `Factura simplificada SII`,
  verifactu_regular_invoice: `Factura regular Verifactu`,
  sii_regular_invoice: `Factura regular SII`,
  verifactu_debit_note: `Nota de débito Verifactu`,
  sii_credit_note: `Nota de crédito SII`,
  verifactu_credit_note: `Nota de crédito Verifactu`,
  sii_corrective_invoice: `Factura rectificativa SII`,
  verifactu_corrective_invoice: `Factura rectificativa Verifactu`,
  sdi_regular_invoice: `Factura regular SDI`,
  corrective_invoice: `Factura rectificativa`,
  replacement_invoice: `Factura sustitutiva`,

  sdi_credit_note: `Nota de crédito SDI`,
  purchase_order: `Orden de compra`,
  delivery_note: `Nota de entrega`,
  document_information: `Información del Documento`,
  customer_information: `Información al cliente`,
  vendor_information: `Informacion del proveedor`,
  items_information: `Información de los artículos`,
  taxes_information: `Información de impuestos`,
  discounts_information: `Información de descuentos`,
  recurring_invoice: `Factura recurrente`,
  recurring_invoice_information: `Información de factura recurrente`,
  upload_document: `Subir documento`,
  "attach_support_document_(optional)": `Adjuntar documento de apoyo (opcional)`,

  // document info fields
  account_class: `Clase de cuenta`,
  document_class: `Clase de documento`,
  documentNumber: `Número de seguimiento`,
  documentDate: `Fecha del documento`,
  poNumber: `Número de pedido`,
  deliveryNote: `Nota de entrega`,
  dueDate: `Fecha de vencimiento`,
  ExpenseCategory: `Categoría de gasto`,
  comments: `Comentarios`,
  rectificationReason: `Motivo de la rectificación`,
  SpainCorrectionCode: `Código de rectificación`,

  // company / contact
  companyName: `Nombre de la empresa`,
  companyID: `ID de empresa`,
  companyEmail: `Correo electrónico de la empresa`,
  companyAddress: `Dirección de la empresa`,
  email_address: `Dirección de email`,
  logo_url: `URL del logotipo`,
  Currency: `Divisa`,

  // customer address breakdown
  CustomerCompanyStreet: `Calle de la empresa cliente`,
  CustomerCompanyStreetNumber: `Número de calle de la empresa cliente`,
  CustomerCompanyLocality: `Localidad de la empresa cliente`,
  CustomerCompanyRegion: `Región de la empresa cliente`,
  CustomerCompanyZipCode: `Código postal de la empresa cliente`,
  CustomerCountry: `País del cliente`,
  customerCompanyStreet_is_missing: `Falta la calle de la empresa cliente`,
  customerCompanyStreetNumber_is_missing: `Falta el número de calle de la empresa cliente`,
  customerCompanyLocality_is_missing: `Falta la localidad de la empresa cliente`,
  customerCompanyRegion_is_missing: `Falta la región de la empresa cliente`,
  customerCompanyZipCode_is_missing: `Falta el código postal de la empresa cliente`,

  // vendor address breakdown
  VendorCompanyStreet: `Calle de la empresa`,
  VendorCompanyStreetNumber: `Número de calle de la empresa vendedora`,
  VendorCompanyLocality: `Localidad de la empresa vendedora`,
  VendorCompanyRegion: `Región de la empresa vendedora`,
  VendorCompanyZipCode: `Código postal de la empresa vendedora`,
  VendorCountry: `País del vendedor`,

  // buttons / status
  submit: `Someter`,
  submit_and_create_new_document: `Enviar y crear un nuevo documento`,
  configuration: `Configuración`,
  document_created_successfully: `Documento creado exitosamente`,

  // stacked layout (new UI)
  create_compliance_standard_document: `Crear {{complianceStandard}} {{documentType}}`,
  customize_invoice_sequencing: `Personalizar la secuencia de facturas`,
  configure_document_series: `Configurar serie de documentos`,
  regular_invoice: `Factura Regular`,
  verifactu: `Verifactu`,
  sdi: `SDI`,
  sii: `SII`,
  logo_url_missing: `Falta la URL del logotipo`,
  edit_vendor_information: `Editar información del proveedor`,
  fill_vendor_details: `Complete los detalles del proveedor para agregarlo a su lista`,
  add_logo_url: `Agregar URL del logotipo`,
  vendor_address: `Dirección del proveedor`,
  vendor_email_address: `Correo electrónico del proveedor`,
  company_street: `Calle de la empresa`,
  company_street_number: `Número de calle`,
  company_locality: `Localidad`,
  company_zip_code: `Código postal`,
  company_region: `Región`,
  document_date: `Fecha del documento`,
  add_po_number: `Agregar número de OC`,
  po_number: `Número de OC`,
  add_delivery_note: `Agregar nota de entrega`,
  add_pec_code: `Agregar código PEC`,
  pec_code: `Código PEC`,
  pec_code_is_missing: `Falta el código PEC`,
  add_destination_code: `Agregar código de destino`,
  destination_code: `Código de destino`,
  destination_code_is_missing: `Falta el código de destino`,
  invoice_information: `Información de la factura`,
  purchase_order_information: `Información de la orden de compra`,
  delivery_note_information: `Información de la nota de entrega`,
  purchase_requisition: `Solicitud de compra`,
  requester_information: `Información del solicitante`,
  requester_name: `Nombre del solicitante`,
  company_id: `ID de la empresa`,
  department_dimension_id: `Departamento`,
  cost_center_dimension_id: `Centro de costo`,
  request_information: `Información de la solicitud`,
  priority: `Prioridad`,
  due_delivery_date: `Fecha de entrega`,
  requirement_justification: `Justificación del comercial`,
  ship_to_address: `Dirección de envío`,
  requesterName_is_required: `El nombre del solicitante es obligatorio`,
  companyId_is_required: `El ID de la empresa es obligatorio`,
  priority_is_required: `La prioridad es obligatoria`,
  dueDeliveryDate_is_required: `La fecha de entrega es obligatoria`,
  requirementJustification_is_required: `La justificación del requerimiento es obligatoria`,
  shipToAddress_is_required: `La dirección de envío es obligatoria`,
  connected_documents: `Documentos conectados`,
  search_or_add_a_new_customer: `Buscar o agregar un nuevo cliente`,
  "no_items_added-click_on_add__line_item_to_add_items": `No se han agregado artículos — haga clic en "Agregar artículo" para agregarlos`,
  line_items: `Artículos`,
  add_line_item: `Agregar artículo`,
  search_by_reference_code_or_description_or_add_new_item: `Buscar por código de referencia o descripción, o agregar nuevo artículo`,
  search_by_reference_code_description_keywords: `Buscar por código, descripción, palabras clave`,
  add_discount: `Agregar descuento`,
  also_add_this_item_to_catalog: `Agregar también este artículo al catálogo`,
  total_breakdown: `Desglose total`,
  subtotal: `Subtotal`,
  tax: `Impuesto`,
  discount: `Descuento`,
  wht_tax: `Retención`,
  total_amount: `Importe total`,
  additional_options: `Opciones adicionales`,
  additional_tax: `Impuesto adicional`,
  support_documents: `Documento de soporte`,
  supporting_documents: `Documento de respaldo`,
  discount_type: `Tipo de descuento`,
  amount: `Importe`,
  percentage: `Porcentaje`,
  base_amount: `Importe base`,
  make_recurring_invoice: `Hacer factura recurrente`,
  preview_pdf: `Vista previa PDF`,
  cancel: `Cancelar`,
  monthly: `Mensual`,
  yearly: `Anual`,
  add_item: `Agregar artículo`,
  update_item: `Actualizar artículo`,
  taxes_permission_required: `Se requiere permiso de impuestos`,
  add_tax: `Agregar impuesto`,
  add_new_tax: `Agregar nuevo impuesto`,
  edit_tax: `Editar impuesto`,
  rate: `Tasa`,
  is_withholding_tax: `Es impuesto de retención`,
  VAT_label: `VAT - Impuesto sobre el Valor Añadido`,
  IGIC_label: `IGIC - Impuesto General Indirecto Canario`,
  IRPF_label: `IRPF - Impuesto sobre la Renta de las Personas Físicas`,
  WHT_label: `WHT - Impuesto de retención`,
  tax_type_required: `El tipo de impuesto es obligatorio`,
  rate_required: `La tasa es obligatoria`,
  rate_min: `La tasa debe ser mayor o igual a 0`,
  tax_created_success: `Impuesto creado exitosamente`,
  tax_updated_success: `Impuesto actualizado exitosamente`,
  error_fetching_tax_data: `Error al obtener los datos del impuesto`,
  update: `Actualizar`,

  // modal de edición de cliente
  edit_customer_information: `Editar información del cliente`,
  fill_customer_details: `Complete los datos del cliente para agregarlo a su lista`,
  customer_address: `Dirección del cliente`,
  customer_company_name: `Nombre del cliente`,
  customer_company_ID: `ID del cliente`,
  customer_email_address: `Correo electrónico del cliente`,
  customerCurrency_is_required: `La moneda del cliente es obligatoria`,
  currency: `Moneda`,
  delete_customer_title: `¿Está seguro de que desea eliminar al cliente?`,
  delete_customer_warning: `Eliminar al cliente no lo borrará, pero sí lo eliminará de su factura`,
  delete_vendor_title: `¿Está seguro de que desea eliminar al proveedor?`,
  delete_vendor_warning: `Eliminar al proveedor no lo borrará, pero sí lo eliminará de su factura`,
  item_delete_title: `¿Está seguro de que desea eliminar este artículo(s)?`,
  item_delete_warning: `Eliminar el artículo lo eliminará de su factura`,
  // opciones adicionales
  item_level_discount_already_added: `Ya hay un descuento aplicado a nivel de artículo. Deshabilítelo antes de agregar un descuento a nivel de documento.`,

  // modal de serie de documentos (nuevo UI)
  customize_invoice_sequencing_number: `Personalizar el número de secuencia de facturas`,
  sequence_number_sub_text: `Cree una nueva regla de numeración, o vea las reglas existentes y anteriores`,
  add_new_sequencing_rule: `Agregar nueva regla de numeración`,
  add_new_sequence_rule_description: `Agregar una nueva regla reemplaza la regla activa actual`,
  add_new_rule: `Agregar nueva regla`,
  starting_number: `Número inicial`,
  delete_series: `¿Eliminar serie?`,
  delete_series_warning: `Eliminar esta serie la eliminará de su documento.`,
  deactive_series: `Serie desactivada`,
  deactivate: `Desactivar`,
  deactivate_sequence_title: `¿Desactivar esta secuencia?`,
  deactivate_sequence_note: `Nota: Necesitará una secuencia activa para crear nuevas facturas.`,
  add_new: `Agregar nuevo`,
  add_series_warning: `Al añadir esta serie se reemplazará la activa. ¿Continuar?`,
  select_or_type_vendor_company_id: `Seleccionar ID de empresa proveedora`,
  invoicecompliance_module_not_enabled: `El módulo de cumplimiento de facturas no está habilitado.`,
  please_enter_company_name: "Por favor, ingrese un nombre de empresa",
  please_select_company_id: "Por favor, seleccione un ID de empresa",
  please_select_country: "Por favor, seleccione un país",
  please_select_currency: "Por favor, seleccione una moneda",
  tax_type_is_required: "El tipo de impuesto es obligatorio",
  tax_percentage_is_required: "El porcentaje de impuesto es obligatorio",
  click_to_upload: `Haga clic para subir`,
  no_invoice_number: "Sin número de factura",
  created_in_dost_portal_edit_message: "Este documento se creó en el Portal Dost, por lo que no hay ningún documento para revisar. Edítelo directamente",
  file_size_exceeds: "El tamaño del archivo excede los 5MB",
  "supported_document.pdf": `documento_soporte.pdf`,
  delivery_note_required: `La nota de entrega es obligatoria`,
  poNumber_is_required: `El número de orden de compra es obligatorio`,
  scheme_id_required: `El ID del esquema es obligatorio si se proporciona el ID del participante`,
  participant_id_required: `El ID del participante es obligatorio si se proporciona el ID del esquema`,
  vendor_inbox: `Bandeja de entrada del proveedor`,
  select_peppol_configuration: `Configuración de Peppol`,
  customer_inbox: `Bandeja de entrada del cliente`,
  customer_peppol_scheme_id: `ID del esquema Peppol del cliente`,
  customer_peppol_participant_id: `ID del participante Peppol del cliente`,
  payment_terms: `Términos de pago`,
  payment_terms_is_required: `Los términos de pago son obligatorios para facturas francesas`,
  save_draft_before_leaving: `¿Guardar como borrador antes de salir?`,
  save_as_draft_subtitle: `Tus cambios no se han guardado. ¿Deseas guardarlos como borrador antes de salir?`,
  need_by_date: `Fecha límite de entrega`,
  business_justification: `Justificación comercial`,
  dueDeliveryDate_cannot_be_past: `Due delivery date must be today or a future date`,
  purchase_requisition_required: "La requisición de compra es obligatoria.",
  document_number_must_be_empty:
    "El número de documento se genera automáticamente y no debe proporcionarse.",
  company_id_required: "El ID de la empresa es obligatorio.",
  department_dimension_id_required:
    "El ID de la dimensión del departamento es obligatorio.",
  purchase_requisition_items_required: "Se requiere al menos un artículo.",
  currency_required: "La moneda es obligatoria.",
  ship_to_address_required: "La dirección de entrega es obligatoria.",
  item_reference_code_required:
    "El código de referencia del artículo es obligatorio.",
  item_description_required: "La descripción del artículo es obligatoria.",
  item_quantity_invalid: "La cantidad del artículo '{0}' debe ser mayor que 0.",
  item_unit_price_invalid:
    "El precio unitario del artículo '{0}' debe ser mayor que 0.",
  document_number_already_assigned:
    "El número de documento '{0}' ya existe. Proporcione un número de documento único.",
  cost_center_is_required: `El centro de costos es obligatorio`,
  department_is_required: `El departamento es obligatorio`,
  extra_fields: `Campos adicionales`,
  erp_field_mappings: `Asignaciones de campos ERP`,
  erp_fields_note: `Configure las asignaciones de campos ERP para este documento`,
  additional_fields: `Campos adicionales`,
  purchase_order_is_being_processing: `La orden de compra se está procesando`,
} as const;
